module.exports = __webpack_public_path__ + "static/media/instruments-english.033fdea0.png";